
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { ObjectShiftListService } from '../services/object-shift-list.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ShiftDateShareService } from '../services/shift-date-share.service';
import { ObjectListService, ObjectNode } from '../services/object-list.service';
import { MatDialog } from '@angular/material/dialog';
import { ManualLoadDialogData } from '../manual-load-dialog/manual-load-dialog';
import { first, filter } from 'rxjs/operators';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { NgFor, NgIf, NgClass, DatePipe } from '@angular/common';
import { MatDivider } from '@angular/material/list';
import { DateConversionPipe } from '../pipes/date-conversion.pipe';
import { WeekMonthConversionPipe } from '../pipes/week-month-conversion.pipe';

@Component({
    selector: 'app-shift-list',
    templateUrl: './shift-list.component.html',
    styleUrls: ['./shift-list.component.scss'],
    imports: [MatButton, MatMenuTrigger, MatIcon, MatMenu, NgFor, MatMenuItem, NgIf, MatDivider, NgClass, DatePipe, DateConversionPipe, WeekMonthConversionPipe]
})
export class ShiftListComponent implements OnInit {
  shiftSubscription: Subscription;
  dsShiftList: {};
  selectedShiftDate: string;
  selectedShift: string;
  site: string;
  objAliasTitle: string;
  lineTitle: string;
  environment: string;
  object: string;
  histShiftList: {};
  histWeekList: {};
  histBiWeeklyList: {};
  histMonthList: {};
  histAnnualList: {};
  activeShiftList: {};
  activeWeekList: {};
  activeBiWeeklyList: {};
  activeMonthList: {};
  activeAnnualList: {};
  test:boolean = true;
  siteTitle: string;
  eamAsset: string;

  currentPlant:ObjectNode = <ObjectNode><unknown>[];

  showActiveDaily:boolean = false;
  showActiveWeekly:boolean = false;
  showActiveBiweekly:boolean = false;
  showActiveMonthly:boolean = false;
  showActiveAnnual:boolean = false;
  showHistoricDaily:boolean = false;
  showHistoricWeekly:boolean = false;
  showHistoricBiweekly:boolean = false;
  showHistoricMonthly:boolean = false;
  showHistoricAnnual:boolean = false;
  showNoActiveChecklist:boolean = false;
  showNoHistoricChecklist:boolean = false;
  manualLoadEnabled: boolean = false;

  readOnlyuser: boolean = false;
  
  @Output() SHIFTDATE = new EventEmitter<string>();
  @Output() shift = new EventEmitter<string>();
  
  constructor(
    private objShiftListService: ObjectShiftListService,
    private route: ActivatedRoute,
    private router: Router,
    private shiftDateShare: ShiftDateShareService,
    private objListService: ObjectListService,
    private geaMesCognito: GeaMesCognitoAuthService,
    private dialog: MatDialog
  ) { 
    this.site = this.route.snapshot.paramMap.get('site');
    this.environment = this.route.snapshot.paramMap.get('environment');
    this.object = this.route.snapshot.paramMap.get('object');
    this.eamAsset = this.route.snapshot.paramMap.get('eamAsset')
    
    this.geaMesCognito.isUserEmployeeOrAuthorized().pipe(filter(x => x!= null), first()).subscribe(
      employee => {
        if (!employee) {
          this.readOnlyuser = true;
        } else {
          this.readOnlyuser = false;
        }
      }
    )

  }

  ngOnInit() {
    this.getShifts()
    this.getObjectDescription()
  }

  getShifts(){
    this.shiftSubscription = this.objShiftListService.objectShiftListSubscription(this.site, this.environment, this.object).subscribe((
      out => {

        let validShift: boolean = false;
        this.activeShiftList = out.Body["active"]["Daily"];
        this.activeWeekList = out.Body["active"]["Weekly"];
        this.activeBiWeeklyList = out.Body["active"]["BiWeekly"];
        this.activeMonthList = out.Body["active"]["Monthly"];
        this.activeAnnualList = out.Body["active"]["Annual"];
        this.histShiftList = out.Body["historic"]["Daily"];
        this.histWeekList = out.Body["historic"]["Weekly"];
        this.histBiWeeklyList = out.Body["historic"]["BiWeekly"];
        this.histMonthList = out.Body["historic"]["Monthly"];
        this.histAnnualList = out.Body["historic"]["Annual"];

        for (let shift in this.activeShiftList) {
          if (this.selectedShiftDate == this.activeShiftList[shift]["SHIFTDATE"] && this.selectedShift == this.activeShiftList[shift]["SHIFT"]) {
            validShift = true;
          }
        }

        if (!validShift) {
          this.selectedShift = "";
          this.selectedShiftDate = "";
        }

        if(this.activeShiftList !== undefined){ if(this.activeShiftList["length"] > 0){ this.showActiveDaily = true; }}
        if(this.activeWeekList !== undefined){ if(this.activeWeekList["length"] > 0){ this.showActiveWeekly = true; }}
        if(this.activeBiWeeklyList !== undefined){ if(this.activeBiWeeklyList["length"] > 0){ this.showActiveBiweekly = true; }}
        if(this.activeMonthList !== undefined){ if(this.activeMonthList["length"] > 0){ this.showActiveMonthly = true; }}
        if(this.activeAnnualList !== undefined){ if(this.activeAnnualList["length"] > 0){ this.showActiveAnnual = true; }}
        if(this.histShiftList !== undefined){ if(this.histShiftList["length"] > 0){ this.showHistoricDaily = true; }}
        if(this.histWeekList !== undefined){ if(this.histWeekList["length"] > 0){ this.showHistoricWeekly = true; }}
        if(this.histBiWeeklyList !== undefined){ if(this.histBiWeeklyList["length"] > 0){ this.showHistoricBiweekly = true; }}
        if(this.histMonthList !== undefined){ if(this.histMonthList["length"] > 0){ this.showHistoricMonthly = true; }}
        if(this.histAnnualList !== undefined){ if(this.histAnnualList["length"] > 0){ this.showHistoricAnnual = true; }}

        if(!this.showActiveDaily && !this.showActiveWeekly && !this.showActiveBiweekly && !this.showActiveMonthly){ this.showNoActiveChecklist = true; }
        if(!this.showHistoricDaily && !this.showHistoricWeekly && !this.showHistoricBiweekly && !this.showHistoricMonthly){ this.showNoHistoricChecklist = true; }
      }
    ));
  }

  getObjectDescription(){

    this.objListService.objectList().subscribe( 
      out=> {
        let sites:ObjectNode[] = out.Body.filter( x => [this.environment].includes(x.environment));

        for (const site of sites) {
          if (site.children) {
            let foundNode = this.objListService.findObject(site.children, this.object);

            if (foundNode) {
              this.objAliasTitle = foundNode['description'] || this.object;
              this.lineTitle = foundNode['Level1'] || '';
              this.siteTitle = site['description'];
              this.manualLoadEnabled = foundNode['ManualLoad'] == 1;

              this.currentPlant = site;
              break;
            }
          }
        }

        if (!this.currentPlant) {
          console.warn('Object description not found for object:', this.object);
        }

      }
    )
  }

  selectShift(shiftDate: string, shift: string, checklistType: string, mode: string){
    let convertShiftDateStr: string 
    convertShiftDateStr = shiftDate
    this.shiftDateShare.changeShiftDate(convertShiftDateStr)
    this.shiftDateShare.changeShift(shift ? shift : "NONE")
    this.shiftDateShare.changeDescription(this.objAliasTitle)
    this.routeToTaskList(checklistType, mode)
  }

  changeObject(site:string, environment:string, objectid:string) {
    this.router.navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['/tasklist', site, environment, objectid]));
  }

  routeToTaskList(checklistType: string, mode: string){
    this.router.navigate(['/tasklist', this.site, this.environment, this.object, mode, checklistType])
  }

  openManualLoad() {
    const dialogRef = this.dialog.open(ManualLoadDialogData, {
      width: '550px',
      data: {
        site: this.site,
        environment: this.environment,
        objectID: this.object,
        objectDescription: this.objAliasTitle
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.showActiveDaily = false;
        this.showActiveWeekly = false;
        this.showActiveBiweekly = false;
        this.showActiveMonthly = false;
        this.showActiveAnnual = false;
        this. showNoActiveChecklist = false;
        this.getShifts();
      }
    });
  }

}
